<dxc-accordion id="textMessage"
      label="{{label}}"
      iconSrc="{{iconSrc}}"
      assistiveText="{{assistiveText}}"
      [disabled] = "disabled"
      [isExpanded] = "isExpanded"
      (onClick)="onItemClick($event)"
      [margin]="margin"
      [padding]="padding"
      [tabIndexValue]="tabIndexValue">
      <ng-container [ngTemplateOutlet]="childTemplate"></ng-container>
</dxc-accordion>
